<template>
  <section class="mt-40 mt-80">
    <div class="container">
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-8">
          <div align="center">
            <div class="message_circle">
              <i class="far fa-envelope icon_message"></i>
            </div>
            <h2 class="page-title">{{$t("auth.signUp.title")}}</h2>
            <div class="row">
              <div class="col-md-2"></div>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-12">
                    <InputForm v-model="user.email"
                      :placeholder="$t('auth.reqEmail')"
                      v-validate="'required|email'"
                      name="email" />
                  </div>
                  <div class="col-md-12">
                    <InputForm v-model="user.first_name"
                      :placeholder="$t('auth.reqName')"
                      v-validate="'required'"
                      :name="$t('auth.name')" />
                  </div>
                  <div class="col-md-12">
                    <InputForm v-model="user.middle_name"
                      :placeholder="$t('auth.reqMiddleName')"
                      v-validate="'required'"
                      :name="$t('auth.middleName')" />
                  </div>
                  <div class="col-md-12">
                    <InputForm v-model="user.last_name"
                      :placeholder="$t('auth.lastName')"
                      name="last_name" />
                  </div>
                  <hr />
                  <div v-for="(customField, index) in customFields" class="col-md-12" :key="index">
                      <InputForm 
                        v-if="customField.kind == 'text'"
                        v-model="customFieldValues[index].value"
                        :placeholder="customField.label"
                        :obligatory="customField.required"
                        :label="customField.label"
                        v-validate="validations(customField)"
                        :name="customField.label"
                      />

                      <DateForm
                        v-if="customField.kind == 'date'"
                        v-model="customFieldValues[index].value"
                        :placeholder="customField.label"
                        :obligatory="customField.required"
                        :label="customField.label"
                        v-validate="validations(customField)"
                        :name="customField.label"
                      />

                      <SelectForm 
                        v-if="customField.kind == 'options'"
                        v-model="customFieldValues[index].value"
                        :label="customField.label"
                        :obligatory="customField.required"
                        :name="customField.label"
                        empty-option="Seleccione"
                      >
                        <option v-for="(option, idx) in customField.options" :key="idx" :value="option">
                          {{ option }}
                        </option>
                      </SelectForm>
                  </div>
                  <!--div class="col-md-12">
                    <InputForm v-model="user.password"
                      :placeholder="$t('auth.reqPassword')"
                      v-validate="'required|min:6'"
                      name="password"
                      type="password"
                      ref="password" />
                    <div class="text-start">
                      <span class="auth-link auth-legend">
                        {{$t('auth.signUp.minPassword')}}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <InputForm v-model="user.password_confirmation"
                      :placeholder="$t('auth.confirmPassword')"
                      v-validate="'required|confirmed:password'"
                      :name="$t('auth.confirmPassword')"
                      type="password"
                      data-vv-as="password" />
                  </div-->
                  <div class="col-md-12">
                    <button type="submit" class="auth-button" @click="create">
                      {{$t("auth.signUp.create")}}
                    </button>
                    <p class="auth-link mt-30">
                      {{$t("auth.signIn.hasAccount")}}
                      <a @click="signIn">
                        {{$t("auth.signIn.title")}}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-2"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-2"></div>
      </div>
    </div>
  </section>
</template>

<script>
import User from '../../models/User';
import DateForm from '../../components/DateForm';
import InputForm from '../../components/InputForm';
import SelectForm from '../../components/SelectForm';
import { CustomFieldApi } from '../../api/CustomFieldApi';

export default {
  name: 'Auth.SignUp',
  components: {
    DateForm,
    InputForm,
    SelectForm
  },
  data() {
    return {
      display: false,
      loading: true,
      email: '',
      section: 'sign_up',
      user: {
        email: null,
        first_name: null,
        middle_name: null,
        last_name: null
      },
      customFields: [],
      customFieldValues: []
    }
  },
  async mounted() {
      const fields = await CustomFieldApi.fetch();
      this.customFields = fields.filter(field => field.section == this.section);

      this.customFieldValues = this.customFields.map(customField => {
        return {
          custom_field_id: customField.id,
          value: ''
        }
      });
  },
  methods: {
    async create() {
      let valid = await this.isValid
      if(valid) {
        this.$root.$emit('showLoader');
        let user = new User();
        this.user.custom_field_values_attributes = this.customFieldValues;

        user.signUp(this.user).then((response) => {
          this.$root.$emit('hideLoader')
          this.$alertify.success(this.$t('auth.signUp.success'))
          setTimeout(() => { location.href = '/'}, 6000)
        }).catch((e) => {
          this.$root.$emit('hideLoader')
          let errors = e.response.response.data.error
          let message = ''

          for(let key in errors) {
            message = `${key} ${errors[key]}`
          }
          this.$alertify.error(message)
        })
      }
    },
    signIn() {
      this.$root.$emit('openSignIn')
    },
    validations(customField) {
        return customField.required ? 'required' : '';
    },
  },
  computed: {
    async isValid() {
      return await this.$validator.validate().then(valid => {
        return valid
      })
    }
  }
}
</script>

<style lang="scss">
</style>
